module.exports = __webpack_public_path__ + "static/img/img-aboutus-03.8ed8830.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-aboutus-03.png
// module id = 3fsX
// module chunks = 1